export const getRoundedValues = (data: number): number => Math.round((data + Number.EPSILON) * 100) / 100;
